import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  TextInput,
  Row,
  Column,
  Select,
  SelectItem,
  PasswordInput,
  ButtonSet,
} from "carbon-components-react";
import { SaveModel24 } from "@carbon/icons-react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import http from "../../http-common";
import {
  userSchema,
  passwordRules,
} from "../../services/SchemaService";
import * as yup from "yup";
import { AuthContext } from "../../contexts/AuthContext";
import { useContext } from "react";
import useGet from "../../hooks/useGet";


const changePasswordSchema = passwordRules.concat(
  yup.object({
    currentPassword: yup.string().required("Campo obrigatório"),
  })
);

const UserProfilePage = () => {

  const { data: roles } = useGet("/lookup/user-roles");
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState({});

  const authContext = useContext(AuthContext);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ resolver: yupResolver(userSchema), mode: "onBlur" });

  const {
    register: registerPwd,
    handleSubmit: handleSubmitPwd,
    reset: resetPwd,
    formState: { errors: errorsPwd },
  } = useForm({ resolver: yupResolver(changePasswordSchema), mode: "onBlur" });

  const onProfileSubmit = async (data) => {
    try {
      await http.put('/users', data);
      toast.success("Dados actualizados com sucesso!");
    } catch (error) {
      toast.error(error.response?.data.message);
    }
  };

  const onPasswordSubmit = async (data) => {
    try {
      await http.put('/users/change-password', {
        username: getValues('username'),
        currentPassword: data.currentPassword,
        newPassword: data.password,
      });
      toast.success("Senha alterada com sucesso!");
      setShowPassword(false);
      resetPwd();
    } catch (error) {
      toast.error(error.response?.data.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await http.get('/users/' + authContext.user.username);
        const fields = [
          "id",
          "username",
          "firstName",
          "lastName",
          "email",
          "roleCode",
          "roleDescription"
        ];
        fields.forEach((field) => setValue(field, user[field]));
        setUser(result.data);
      } catch (error) {
        toast.error(error.response?.data.message);
      }
    };

    fetchData();

  }, []);

  useEffect(() => {
    reset(user);
  }, [user]);

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Meu Perfil</h3>
      </div>
      <div className="card-body">
        <Form onSubmit={handleSubmit(onProfileSubmit)}>
          <Row>
            <Column sm={6} md={6} lg={6}>
              <TextInput
                id="firstName"
                labelText="Nome"
                maxLength={64}
                {...register("firstName")}
              />
              <p className="field-error">{errors.firstName?.message}</p>
            </Column>
            <Column sm={6} md={6} lg={6}>
              <TextInput
                id="lastName"
                labelText="Apelido"
                maxLength={64}
                {...register("lastName")}
              />
              <p className="field-error">{errors.lastName?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column sm={12} md={6} lg={6}>
              <TextInput
                id="username"
                labelText="Número de telefone"
                {...register("username")}
                maxLength={9}
              />
              <p className="field-error">{errors.username?.message}</p>
            </Column>
            <Column sm={12} md={6} lg={6}>
              <TextInput id="email" labelText="Email" {...register("email")} />
              <p className="field-error">{errors.email?.message}</p>
            </Column>
          </Row>
          <Row>
            <Column sm={2} md={6} lg={6}>
              <Select
                id="roleCode"
                labelText="Perfil"
                {...register("roleCode")}
                disabled={true}
              >
                <SelectItem text="" value="" />
                {roles.map((p) => (
                  <SelectItem
                    text={p.description}
                    value={p.code}
                    key={p.code}
                  />
                ))}
              </Select>
              <p className="field-error">{errors.roleCode?.message}</p>
            </Column>
          </Row>
          <Row className="mt-2">
            <Column sm={12} md={12} lg={12} className="form-buttons">
              <ButtonSet>
                <Button
                  type="submit"
                  renderIcon={SaveModel24}
                  iconDescription="Save"
                >
                  Salvar
                </Button>
              </ButtonSet>
              {!showPassword && (
                <ButtonSet>
                  <Button
                    type="button"
                    onClick={() => setShowPassword(true)}
                    className="emprega-bg-orange"
                  >
                    Alterar Senha
                  </Button>
                </ButtonSet>
              )}
            </Column>
          </Row>
        </Form>

        {showPassword && (
          <Form onSubmit={handleSubmitPwd(onPasswordSubmit)} className="mt-2">
            <Row>
              <Column sm={12} md={6} lg={6}>
                <PasswordInput
                  id="currentPassword"
                  labelText="Senha Actual"
                  maxLength={16}
                  {...registerPwd("currentPassword")}
                />
                <p className="field-error">{errorsPwd.currentPassword?.message}</p>
              </Column>
            </Row>
            <Row>
              <Column sm={12} md={6} lg={6}>
                <PasswordInput
                  id="password"
                  labelText="Nova Senha"
                  maxLength={16}
                  {...registerPwd("password")}
                />
                <p className="field-error">{errorsPwd.password?.message}</p>
              </Column>
              <Column sm={12} md={6} lg={6}>
                <PasswordInput
                  id="passwordConfirm"
                  labelText="Confirmação da Senha"
                  maxLength={16}
                  {...registerPwd("passwordConfirm")}
                />
                <p className="field-error">{errorsPwd.passwordConfirm?.message}</p>
              </Column>
            </Row>
            <Row className="mt-2">
              <Column sm={12} md={12} lg={12} className="form-buttons">
                <ButtonSet>
                  <Button
                    type="submit"
                    renderIcon={SaveModel24}
                    iconDescription="Save"
                  >
                    Confirmar Alteração
                  </Button>
                </ButtonSet>
                <ButtonSet>
                  <Button
                    type="button"
                    kind="secondary"
                    onClick={() => { setShowPassword(false); resetPwd(); }}
                  >
                    Cancelar
                  </Button>
                </ButtonSet>
              </Column>
            </Row>
          </Form>
        )}
      </div>
    </div>
  );
};

export default UserProfilePage;
